import type { MerchantPredictionsReport } from '../../services/analytics.api';
import { cn } from '../../utils/cn';
import { Panel } from '../ui/Panel';
import { tbl } from '../ui/table';

export default function MerchantPredictions({ predictions }: { predictions?: MerchantPredictionsReport }) {
  return (
    <Panel title="Merchant predictions" subtitle="Learned from the last 30 days of completed pickups">
      <p className="mb-3 text-[12px] text-gray-500 text-pretty">
        Expected orders and predicted visit duration per merchant — the inputs for per-merchant service
        profiles in the route planner. Fallback model: {predictions?.model_fallback.base_min ?? 7.5} min +{' '}
        {predictions?.model_fallback.sec_per_order ?? 15} s/order.
      </p>
      {(predictions?.merchants.length ?? 0) === 0 ? (
        <p className="py-2 text-[13px] text-gray-500">Not enough completed pickups to learn from yet.</p>
      ) : (
        <div className={tbl.wrap}>
          <table className={tbl.table}>
            <thead>
              <tr className={tbl.headRow}>
                <th className={tbl.th}>Merchant</th>
                <th className={cn(tbl.th, tbl.num)}>Pickups / wk</th>
                <th className={cn(tbl.th, tbl.num)}>Expected orders</th>
                <th className={cn(tbl.th, tbl.num)}>Pace s/pkg</th>
                <th className={cn(tbl.th, tbl.num)}>Base min</th>
                <th className={cn(tbl.th, tbl.num)}>Predicted visit</th>
                <th className={tbl.th}>Flag</th>
              </tr>
            </thead>
            <tbody>
              {predictions?.merchants.slice(0, 15).map((m) => (
                <tr key={m.merchant_id} className={tbl.row}>
                  <td className={tbl.td}>
                    <span dir="auto">{m.merchant_name}</span> <span className={tbl.muted}>#{m.merchant_id}</span>
                  </td>
                  <td className={cn(tbl.td, tbl.num)}>{m.pickups_per_week}</td>
                  <td className={cn(tbl.td, tbl.num)}>{m.expected_orders}</td>
                  <td className={cn(tbl.td, tbl.num)}>{m.learned_pace_s_per_order ?? '—'}</td>
                  <td className={cn(tbl.td, tbl.num)}>{m.learned_base_min ?? '—'}</td>
                  <td className={cn(tbl.td, tbl.num, 'font-medium')}>{m.predicted_duration_min} m</td>
                  <td className={tbl.td}>
                    {m.slow_prep && (
                      <span className="inline-flex items-center rounded-full bg-red-50 px-2 py-0.5 text-[11px] font-medium text-red-700">
                        Slow prep
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
